import React, { useState } from "react";
import { PartnerCard } from "./PartnerCard";
import { ArrowRight, Star } from "lucide-react";
import { useToastWrapper } from "@/hooks/useToastWrapper";

// Define the partner data type
interface Partner {
  name: string;
  link: string;
  description: string;
  highlight?: string;
  expandedInfo?: string;
  loanExample?: string;
  recommended?: boolean;
  amount?: string;
  isFixura?: boolean;
}
export const loanPartners: Partner[] = [{
  name: "Axolaina",
  link: "https://go.axolaina.fi/aff_c?offer_id=820&aff_id=1657",
  description: "Joustavaa lainaa ilman vakuuksia, nopealla päätöksellä.",
  highlight: "Rahat tilillesi 24h sisällä hakemuksesta",
  expandedInfo: "Axolaina on lainanvälittäjä, joka kilpailuttaa lainahakemuksesi jopa 18 pankin ja rahoituslaitoksen kesken. Lainasummat vaihtelevat 2 000 € – 60 000 € ja takaisinmaksuaika 1–15 vuotta. Palvelu on maksuton ja voit saada useita lainatarjouksia yhdellä hakemuksella.",
  loanExample: "Esimerkki: 15 000 €, 72 kk, 11,5 % korko, todellinen vuosikorko 12,1 %, kuukausierä 285,80 €, kokonaiskustannukset 20 577,60 €.",
  recommended: true,
  amount: "2 000 € – 60 000 €"
}, {
  name: "Creditstar",
  link: "https://track.adtraction.com/t/t?a=1872564990&as=1854031059&t=2&tk=1",
  description: "Luotettava pienlainapalvelu, rahaa jopa saman päivän aikana.",
  highlight: "Raha tilillesi minuuteissa hyväksymisen jälkeen",
  expandedInfo: "Creditstar on luotettava pienlainapalvelu, joka tarjoaa lainaa jopa 3 000 € ilman vakuuksia. Rahat voidaan siirtää tilillesi jo saman päivän aikana, ja takaisinmaksuaika on joustava.",
  loanExample: "Esimerkki: 2000 €, 36 kk, 19,9 % korko, todellinen vuosikorko 21,7 %, kuukausierä 73,50 €, kokonaiskustannukset 2646 €.",
  recommended: true,
  amount: "Jopa 3 000 €"
}, {
  name: "Bondora",
  link: "https://go.adt256.com/t/t?a=1252699188&as=1854031059&t=2&tk=1",
  description: "Lainaa jopa 10 000 € muutamassa minuutissa – ilman piilokuluja.",
  highlight: "Ei piilokuluja, läpinäkyvät ehdot",
  expandedInfo: "Bondora tarjoaa lainoja jopa 10 000 € muutamassa minuutissa ilman piilokuluja. Hakuprosessi on nopea ja yksinkertainen, ja rahat voidaan siirtää tilillesi jo saman päivän aikana.",
  loanExample: "Esimerkki: 5000 €, 48 kk, 16,9 % korko, todellinen vuosikorko 18,5 %, kuukausierä 142,80 €, kokonaiskustannukset 6854,40 €.",
  recommended: true,
  amount: "Jopa 10 000 €"
}, {
  name: "Ferratum",
  link: "https://go.adt246.net/t/t?a=1083657997&as=1854031059&t=2&tk=1",
  description: "Pitkäaikainen toimija, joka tarjoaa joustavaa lainaa ja luottokortteja nopeasti.",
  highlight: "Kortti käytössäsi virtuaalisena heti hyväksynnän jälkeen",
  expandedInfo: "Ferratum on pitkäaikainen toimija, joka tarjoaa joustavaa lainaa nopeasti. Lainasummat vaihtelevat 500 € – 20 000 €, ja hakuprosessi on täysin digitaalinen ilman vakuuksia.",
  loanExample: "Esimerkki: 3000 €, 24 kk, 18,9 % korko, todellinen vuosikorko 20,7 %, kuukausierä 152,40 €, kokonaiskustannukset 3657,60 €.",
  recommended: true,
  amount: "500 € – 20 000 €"
}, {
  name: "Alisa Pankki",
  link: "https://go.adt231.net/t/t?a=1074300935&as=1854031059&t=2&tk=1",
  description: "Digitaalinen pankki, joka tarjoaa kulutusluottoja ja vakuudettomia lainoja.",
  highlight: "Lainaa jopa 60 000€ omiin tarpeisiisi",
  expandedInfo: "Alisa Pankki tarjoaa vakuudettomia kulutusluottoja 1 000 € – 30 000 € ilman takaajia. Takaisinmaksuaika on joustava, 1–15 vuotta.",
  loanExample: "Esimerkki: 10 000 €, 60 kk, 9,5 % korko, todellinen vuosikorko 9,91 %, kuukausierä 210,40 €, kokonaiskustannukset 13 723 €.",
  amount: "1 000 € – 30 000 €"
}, {
  name: "Unolaina",
  link: "https://go.adt284.net/t/t?a=1791991882&as=1854031059&t=2&tk=1",
  description: "Lainojen vertailupalvelu useista eri rahoituslähteistä.",
  highlight: "Vertaile lainoja 500-60 000€",
  expandedInfo: "Unolaina on lainojen vertailupalvelu, jonka avulla yksityishenkilöt voivat kilpailuttaa lainansa nopeasti ja löytää itselleen edullisimman vaihtoehdon. Palvelu on maksuton ja sitoumukseton.",
  loanExample: "Esimerkki: 5 000 €, 36 kk, 12,9 % korko, todellinen vuosikorko 13,9 %, kuukausierä 168,50 €, kokonaiskustannukset 6 066 €.",
  amount: "500 € – 60 000 €"
}, {
  name: "Bluestep",
  link: "https://go.adt256.com/t/t?a=1540469708&as=1854031059&t=2&tk=1",
  description: "Asuntolainoja ja uudelleenrahoitusratkaisuja joustavilla ehdoilla.",
  highlight: "Ratkaisu myös haastaviin luottotilanteisiin",
  expandedInfo: "Bluestep tarjoaa asuntolainoja ja uudelleenrahoitusratkaisuja henkilöille, joilla on haasteita luottotiedoissa tai epäsäännölliset tulot. Heidän joustavat lainaratkaisunsa mahdollistavat kodin hankinnan tai talouden uudelleenjärjestelyn erilaisissa elämäntilanteissa.",
  loanExample: "Esimerkki: 150 000 €, 240 kk, 4,5 % korko, todellinen vuosikorko 4,8 %, kuukausierä 950,30 €, kokonaiskustannukset 228 072 €.",
  amount: "Joustava asuntolaina"
}, {
  name: "Rensa",
  link: "https://go.adt212.net/t/t?a=1881370063&as=1854031059&t=2&tk=1",
  description: "Vastuullinen velanhoito- ja laskujen yhdistämispalvelu.",
  highlight: "Pienennä kuukausieriä, säästä korkokuluissa",
  expandedInfo: "Rensa on innovatiivinen velanhoitoratkaisu, jonka avulla voit ottaa taloutesi hallintaan. Palvelun avulla voit yhdistää useat lainat ja laskut yhteen edullisempaan kokonaisuuteen, pienentää kuukausittaisia maksujasi ja säästää jopa tuhansia euroja korkokuluissa maksamalla velkasi nopeammin pois. Rensa auttaa luomaan selkeän takaisinmaksusuunnitelman ja tarjoaa työkaluja talouden hallintaan.",
  loanExample: "Esimerkki: 8 000 €, 48 kk, 13,9 % korko, todellinen vuosikorko 14,8 %, kuukausierä 216,40 €, kokonaiskustannukset 10 387,20 €.",
  amount: "1 000 € – 25 000 €"
}, {
  name: "Northmill",
  link: "https://go.adt284.net/t/t?a=1886810581&as=1854031059&t=2&tk=1",
  description: "Lainaa 5000 euroon asti, maksat vain siitä mitä käytät",
  highlight: "Nostot suoraan tilillesi",
  expandedInfo: "Tarjoamme mutkattoman lainan reiluilla ehdoilla silloin, kun tarvitset sitä eniten. Tunnetusti tyytyväiset asiakkaat ja nopea asiakaspalvelu. Vastaamme puheluihin keskimäärin 30 sekunnissa ja meidät tavoittaa reaaliajassa myös chatissa. Mikäli et pysty olemaan meihin yhteydessä asiakaspalvelun aukioloaikojen puitteissa, tavoitat meidät myös sähköpostilla.",
  loanExample: "Esimerkki: 2000 €, 24 kk, 18,9 % korko, todellinen vuosikorko 20,7 %, kuukausierä 102,40 €, kokonaiskustannukset 2457,60 €.",
  amount: "Jopa 5 000 €"
}];

export const microLoanPartners: Partner[] = [{
  name: "Minunraha",
  link: "https://go.adt284.net/t/t?a=1801600351&as=1854031059&t=2&tk=1",
  description: "Pienlainoja nopeasti ja ilman liitteitä, sopii pienempiin tarpeisiin.",
  highlight: "Lainapäätös minuuteissa, rahat heti hyväksynnän jälkeen",
  expandedInfo: "Minunraha tarjoaa pienlainoja nopeasti ja ilman liitteitä. Uusille asiakkaille lainasummat ovat 25–250 €, ja nykyisille asiakkaille jopa 500 €. Lainapäätös tehdään nopeasti, ja rahat siirretään tilille heti hyväksynnän jälkeen.",
  loanExample: "Esimerkki: 200 €, 30 pv, korko 20 %, todellinen vuosikorko 791,6 %, kulut yhteensä 33,33 €, takaisin maksettava yhteensä 233,33 €.",
  amount: "25 € – 500 €"
}, {
  name: "iRaha",
  link: "https://go.adt212.net/t/t?a=1740772893&as=1854031059&t=2&tk=1",
  description: "Pienlainapalvelu nopeisiin tarpeisiin ilman vakuuksia.",
  highlight: "Lainaa 20-2000€ joustavasti",
  expandedInfo: "iRaha on pienlainapalvelu, joka tarjoaa nopeita lainoja 20 € – 2 000 € ilman vakuuksia. Hakemusprosessi on nopea, ja rahat voidaan saada tilille jopa samana päivänä.",
  loanExample: "Esimerkki: 400 €, 60 pv, korko 18 %, todellinen vuosikorko 220,8 %, kulut yhteensä 36 €, takaisin maksettava yhteensä 436 €.",
  amount: "20 € – 2 000 €"
}, {
  name: "Neolaina",
  link: "https://go.adt242.com/t/t?a=1840936976&as=1854031059&t=2&tk=1",
  description: "Lainoja ja yhdistelylainoja kilpailukykyisin ehdoin.",
  highlight: "Yksilöllinen lainatarjous tarpeisiisi",
  expandedInfo: "Neolaina on pienlainapalvelu, joka tarjoaa nopeita lainoja 20 € – 2 000 € ilman vakuuksia. Hakemusprosessi on nopea, ja rahat voidaan saada tilille jopa samana päivänä.",
  loanExample: "Esimerkki: 1 000 €, 90 pv, korko 17 %, todellinen vuosikorko 90,2 %, kulut yhteensä 42,50 €, takaisin maksettava yhteensä 1 042,50 €.",
  amount: "20 € – 2 000 €"
}, {
  name: "Cashday",
  link: "https://go.adt267.com/t/t?a=1801600670&as=1854031059&t=2&tk=1",
  description: "Helppo ja nopea lainapalvelu pienempiin tarpeisiin.",
  highlight: "Lainaa jo 100€ alkaen, nopea käsittely",
  expandedInfo: "Cashday on pienlainapalvelu, joka tarjoaa nopeita lainoja 100 € – 2 000 € ilman vakuuksia. Hakemusprosessi on nopea, ja rahat voidaan saada tilille jopa samana päivänä.",
  loanExample: "Esimerkki: 500 €, 60 pv, korko 19 %, todellinen vuosikorko 199,8 %, kulut yhteensä 47,50 €, takaisin maksettava yhteensä 547,50 €.",
  amount: "100 € – 2 000 €"
}];

export const creditCardPartners: Partner[] = [{
  name: "Lainasto",
  link: "https://go.adt253.net/t/t?a=1481571939&as=1854031059&t=2&tk=1",
  description: "Virtuaalinen luottokortti hyväksytään minuuteissa – saat rahat käyttöösi heti sopimuksen allekirjoituksen jälkeen. Nopea ratkaisu äkillisiin menoihin ilman fyysistä korttia.",
  highlight: "Joustava takaisinmaksu, sinulle sopivissa erissä",
  expandedInfo: "Lainasto tarjoaa virtuaalisia luottokortteja nopeasti ilman vakuuksia. Palvelu on suunnattu henkilöille, jotka tarvitsevat rahaa yllättäviin menoihin tai arjen hankintoihin. Hakemus täytetään verkossa, ja päätös saadaan nopeasti.",
  loanExample: "Esimerkki: Luottoraja 2 000 €, korko 19,9 %, todellinen vuosikorko 21,9 %, kuukausimaksu 5 €, arvioitu kokonaiskustannus 2 249 € kun luotto käytetään kokonaan ja maksetaan 12 kk aikana.",
  amount: "Jopa 3 000 € luottoraja"
}, {
  name: "Ferratum",
  link: "https://go.adt246.net/t/t?a=1083657997&as=1854031059&t=2&tk=1",
  description: "Virtuaalinen luottokortti käytettävissäsi välittömästi hyväksynnän jälkeen. Täysin digitaalinen hakuprosessi, nopea päätös ja luottoraja jopa 8000€ arkeen ja yllättäviin menoihin.",
  highlight: "Täysin digitaalinen prosessi, ei paperitöitä",
  expandedInfo: "Ferratum on pitkäaikainen toimija, joka tarjoaa joustavaa lainaa nopeasti sekä virtuaalisia luottokortteja. Palvelu on suunnattu asiakkaille, jotka arvostavat nopeaa ja helppoa pankkiasiointia mobiililaitteilla.",
  loanExample: "Esimerkki: Luottoraja 4 000 €, korko 18,9 %, todellinen vuosikorko 20,7 %, kuukausimaksu 4 €, arvioitu kokonaiskustannus 4 378 € kun luotto käytetään kokonaan ja maksetaan 12 kk aikana.",
  amount: "Jopa 8 000 € luottoraja"
}, {
  name: "SweepBank",
  link: "https://go.adt242.com/t/t?a=1956672581&as=1854031059&t=2&tk=1",
  description: "Mobiilipankki, joka yhdistää pankkipalvelut ja shoppailun yhdessä sovelluksessa. Saat virtuaalisen Mastercard luottokortin, jossa on jopa 60 päivää korotonta maksuaikaa ja luottorajan 1000-8000€.",
  highlight: "Ei avaus-, kuukausi- tai vuosimaksuja",
  expandedInfo: "SweepBank on osa suomalaista Multitude fintech finanssiryhmää. Palvelu tarjoaa ilmaiset käyttö- ja säästötilit 1% korolla, virtuaalisen Mastercard pankki- ja luottokortin sekä Sweep Deals tarjouksia. Asiakas saa myös jopa 5% takaisin ostojen arvosta kanta-asiakasohjelman kautta.",
  loanExample: "Esimerkki: 1500 € luotto, nimelliskorko 19,9 %, todellinen vuosikorko 21,82 %. Takaisinmaksu 12 kuukauden maksuerissä (138,88 €) kuukausittain. Kokonaiskustannus 1666,56 €, josta kuluja 166,56 €.",
  amount: "1 000 - 8 000 € luottoraja"
}];

export const peerToPeerPartners: Partner[] = [{
  name: "Fixura",
  link: "https://go.adt256.com/t/t?a=1484856588&as=1854031059&t=2&tk=1",
  description: "Vertaislaina ja lainojen yhdistäminen jopa 20 000 €.",
  highlight: "Ihmisiltä ihmisille - yhdistä lainasi edullisemmin",
  expandedInfo: "Fixura tarjoaa vakuudettomia vertaislainoja ja lainojen yhdistämistä jopa 20 000 € asti. Heidän palvelunsa avulla voit yhdistää useita lainoja yhdeksi edullisemmaksi kokonaisuudeksi tai lainata suoraan toisilta ihmisiltä.",
  loanExample: "Esimerkki: 10 000 €, 60 kk, 12,5 % korko, todellinen vuosikorko 13,2 %, kuukausierä 225,75 €, kokonaiskustannukset 13 545 €.",
  isFixura: true,
  amount: "Jopa 20 000 €"
}];

interface PartnersSectionProps {
  activeTab: string;
}
export const PartnersSection = ({
  activeTab
}: PartnersSectionProps) => {
  let partners: Partner[] = [];
  let sectionTitle = "";
  let sectionDescription = "";
  
  if (activeTab === "pienlainat") {
    partners = loanPartners;
    sectionTitle = "Suositellut pienlainatarjoajat";
    sectionDescription = "Pienlainojen vertailu kannattaa! Löydä edullisin vaihtoehto ja säästä satoja euroja korkoihin. Alla olevat kumppanimme tarjoavat kilpailukykyisiä pienlainoja erilaisiin tarpeisiin.";
  } else if (activeTab === "luottokortit") {
    partners = creditCardPartners;
    sectionTitle = "Suositellut luottokortit";
    sectionDescription = "Oikea luottokortti voi tuoda joustoa talouteen ja etuja ostoksiin. Vertaile eri vaihtoehtoja ja valitse itsellesi sopivimmat ominaisuudet.";
  } else if (activeTab === "pikavippi") {
    partners = microLoanPartners;
    sectionTitle = "Pienet lainat (alle 2000€)";
    sectionDescription = "Pienet lainat sopivat äkillisiin ja lyhytaikaisiin rahantarpeisiin. Näiden lainojen hakuprosessit ovat erittäin nopeita ja yksinkertaisia.";
  } else if (activeTab === "vertaislainat") {
    partners = peerToPeerPartners;
    sectionTitle = "Vertaislainat";
    sectionDescription = "Vertaislainaus mahdollistaa lainaamisen suoraan yksityishenkilöiltä ilman perinteistä pankkia välikätenä. Tämä voi johtaa edullisempiin korkoihin ja joustavampiin lainaehtoihin.";
  }

  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  const TabButton = ({
    tabId,
    label
  }: {
    tabId: string;
    label: string;
  }) => {
    const isActive = activeTab === tabId;
    const isHovered = hoveredTab === tabId;
    return <a href={`?tab=${tabId}`} className={`
          relative px-5 py-3 rounded-t-lg transition-all duration-300 font-medium text-center
          ${isActive ? 'bg-gradient-to-br from-purple-600 to-blue-700 text-white shadow-md' : 'bg-white hover:bg-gradient-to-br hover:from-purple-100 hover:to-blue-100'}
          ${isHovered ? 'transform -translate-y-1' : ''}
        `} onMouseEnter={() => setHoveredTab(tabId)} onMouseLeave={() => setHoveredTab(null)}>
        {label}
        {isActive && <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-purple-400 to-blue-400"></span>}
      </a>;
  };

  return <div className="py-8 bg-white border border-gray-200 rounded-lg p-6 mb-8">
      <div className="mb-8">
        
      </div>
      
      <div className="mb-6 border-l-4 border-blue-500 pl-4">
        <h3 className="text-2xl font-semibold text-blue-700">
          {sectionTitle}
        </h3>
        <p className="text-sm text-blue-500 font-medium mt-1">Vertaile ja valitse paras vaihtoehto juuri sinulle</p>
      </div>
      
      <div className="bg-blue-50 p-4 rounded-md mb-6 flex items-center">
        <Star className="h-5 w-5 text-yellow-500 mr-3 flex-shrink-0" />
        <p className="text-gray-700">
          {sectionDescription}
        </p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {partners.map(partner => <PartnerCard key={partner.name} name={partner.name} link={partner.link} description={partner.description} highlight={partner.highlight} expandedInfo={partner.expandedInfo} recommended={partner.recommended} isFixura={partner.isFixura} amount={partner.amount} loanExample={partner.loanExample} />)}
      </div>
    </div>;
};
